import { Tooltip } from '@odo/shared-ui';
import type { Communication } from '../../../../services/communications';
import { channelDef } from './channels';

// Beyond this many distinct channels, the rest collapse into a "+N" pill -
// matches CategoryPillsCapped's own cap-and-summarize shape for a capped
// list of small chips in a fixed-width column.
const MAX_CHANNELS_SHOWN = 3;

// The table's "Interactions" column - one icon+count pair per channel
// present, e.g. "3 calls, 2 emails" at a glance.
export function EntriesCell({ communication }: { communication: Communication }) {
    const counts = communication.entryCountsByChannel;
    if (counts.length === 0) {
        return <span className="text-[13px] text-gray-400 italic">No interactions</span>;
    }

    const shown = counts.slice(0, MAX_CHANNELS_SHOWN);
    const overflow = counts.slice(MAX_CHANNELS_SHOWN);

    return (
        <div className="flex items-center gap-2.5 min-w-0">
            {shown.map(({ channel, count }) => {
                const def = channelDef(channel);
                const Icon = def.icon;
                return (
                    <span key={channel} className="flex items-center gap-1 shrink-0">
                        <Icon className="h-3.5 w-3.5" style={{ color: def.tone }} />
                        <span className="text-[13px] font-semibold text-gray-700 tabular-nums">
                            {count}
                        </span>
                    </span>
                );
            })}
            {overflow.length > 0 && (
                <Tooltip
                    content={overflow
                        .map(({ channel, count }) => `${channelDef(channel).label} ${count}`)
                        .join(', ')}
                >
                    <span className="text-[12px] text-gray-400 font-medium shrink-0">
                        +{overflow.length}
                    </span>
                </Tooltip>
            )}
        </div>
    );
}
